import LocomotiveScroll from "locomotive-scroll";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


class Scroller {
    constructor() {
        this.loco = null;
    }

    init() {
        this.loco = new LocomotiveScroll({
            lenisOptions: {
                lerp: 0.12,
            },
            initCustomTicker: (render) => {
                gsap.ticker.add(render);
            },
            destroyCustomTicker: (render) => {
                gsap.ticker.remove(render);
            },
        });

        // Sync Lenis scroll → ScrollTrigger (cf. exemplos/)
        this.loco.lenisInstance.on("scroll", ScrollTrigger.update);
        gsap.ticker.lagSmoothing(0);

        return this;
    }

    stop() {
        if (this.loco) {
            this.loco.stop();
        }
    }

    start() {
        if (this.loco) {
            this.loco.start();
        }
    }

    resize() {
        if (this.loco) {
            this.loco.resize();
            ScrollTrigger.refresh();
        }
    }

    scrollTo(params) {
        if (this.loco) {
            const { target, options } = params;
            this.loco.scrollTo(target, options);
        }
    }

    getCurrentScroll() {
        return this.loco;
    }

    destroy() {
        if (this.loco) {
            ScrollTrigger.getAll().forEach(t => t.kill());
            this.loco.destroy();
            this.loco = null;
        }
    }

    reset() {
        this.destroy();
        this.init();
    }
}

export default new Scroller();
